<div [innerHtml]="value"></div>